import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { navigate("/pricing"); return; }
    if (attempts >= 6) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/stripe/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          toast.success("Paiement confirmé !");
        } else {
          setAttempts((a) => a + 1);
        }
      } catch {
        setAttempts((a) => a + 1);
      }
    }, 2000);
    return () => clearTimeout(t);
  }, [attempts, sessionId, navigate]);

  return (
    <div className="min-h-screen bg-[var(--surface-alt)] grid place-items-center p-5">
      <div className="bg-[var(--surface)] rounded-xl p-8 max-w-md w-full border border-[var(--border-soft)] shadow-sm text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-[var(--text)] mt-4">Merci pour votre abonnement</h1>
            <p className="text-sm text-zinc-500 mt-2">Votre plan est activé.</p>
            <Button onClick={() => navigate("/dashboard")} className="w-full rounded-full bg-emerald-500/100 hover:bg-emerald-500 mt-6 h-11 font-semibold" data-testid="go-dashboard">Accéder à Prosperr</Button>
          </>
        ) : attempts >= 6 ? (
          <>
            <h1 className="font-display text-2xl font-bold text-[var(--text)]">Paiement en cours de vérification</h1>
            <p className="text-sm text-zinc-500 mt-2">Revois dans quelques minutes.</p>
            <Button onClick={() => navigate("/dashboard")} className="w-full rounded-full mt-6 h-11 font-semibold">Continuer</Button>
          </>
        ) : (
          <>
            <div className="w-12 h-12 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin mx-auto" />
            <h1 className="font-display text-xl font-bold text-[var(--text)] mt-4">Vérification du paiement...</h1>
            <p className="text-xs text-zinc-500 mt-2">Tentative {attempts + 1}/6</p>
          </>
        )}
      </div>
    </div>
  );
}
